<script>
export default {
  name: "Screen",
  data() {
    return {
      id: 0
    };
  },
  methods: {
    async slideInUp() {
      return new Promise((resolve, reject) => {
        this.util.animateCSS(`.screen-${this.id} .inner`, "slideInUp", resolve);
      });
    },
    async slideOutUp() {
      return new Promise((resolve, reject) => {
        this.util.animateCSS(`.screen-${this.id} .inner`, "fadeOutUp", resolve);
      });
    }
  }
};
</script>